import styled from "styled-components";
import { layout, LayoutProps, margin, MarginProps } from "styled-system";

const Container = styled.div<LayoutProps&MarginProps>`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 20px;
  padding-right: 20px;
  ${layout}
  ${margin}
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1300px;
  }
`;

export default Container